/**
 * @Time    : 2022/11/24 10:39
 * @Author  : tlovet
 * @Software: WebStorm
 * 全屏
 */

import { FullscreenExitOutlined, FullscreenOutlined } from '@ant-design/icons';
import React, { useState } from 'react';

export const FullScreen: React.FC = () => {
  const [isFullScreen, setIsFullScreen] = useState<boolean>(true);

  // 进入全屏，兼容多重浏览器
  const requestFullScreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element?.requestFullscreen();
      // @ts-ignore
    } else if (element?.mozRequestFullScreen) {
      // @ts-ignore
      element?.mozRequestFullScreen();
      // @ts-ignore
    } else if (element?.webkitRequestFullScreen) {
      // @ts-ignore
      element?.webkitRequestFullScreen();
      // @ts-ignore
    } else if (element?.msRequestFullscreen) {
      // @ts-ignore
      element?.webkitRequestFullScreen();
    }
  };

  // 退出全屏，兼容多重浏览器
  // // @ts-ignore
  const exitFullscreen = () => {
    if (!document) return;
    if (document?.exitFullscreen) {
      document?.exitFullscreen();
      // @ts-ignore
    } else if (document?.mozCancelFullScreen) {
      // @ts-ignore
      document?.mozCancelFullScreen();
      // @ts-ignore
    } else if (document?.webkitExitFullscreen) {
      // @ts-ignore
      document?.webkitExitFullscreen();
      // @ts-ignore
    } else if (document?.msExitFullscreen) {
      // @ts-ignore
      document?.msExitFullscreen();
    }
  };

  //调用事件
  const fullScreen = () => {
    // @ts-ignore
    // document?.webkitIsFullScreen支持chrome和Safari，返回的是bool
    // document?.fullscreenElement支持Firefox，返回的是null或html
    const currFullScreen = document?.webkitIsFullScreen || document?.fullscreenElement;
    if (!currFullScreen) {
      requestFullScreen();
    } else {
      exitFullscreen();
    }
    // 为兼容document?.fullscreenElement，只能使用!!currFullScreen
    setIsFullScreen(!!currFullScreen);
  };

  return React.createElement(isFullScreen ? FullscreenOutlined : FullscreenExitOutlined, {
    onClick: fullScreen,
  });
};
